import { getItemsFromCollection } from "directus/src/operations";

export async function fetchSurveysProjectAverage({ id }) {
  try {
    const query = {
      fields: [
        "id",
        "job",
        "job.project.id",
        "job.project.project_id",
        "questions.id",
        "questions.question",
        "questions.questions_id.question",
        "questions.question.question",
        "questions.question.category.name",
        "questions.response",
      ],
      filter: {
        job: {
          project: {
            _eq: id,
          },
        },
        status: {
          _eq: "submitted",
        },
      },
    };
    const response = await getItemsFromCollection("surveys", query);

    // Simply return the array of surveys
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

